export const Categories = [
    "Bread","Brownie","Cheese Cake","Cookies","Cup Cake","Jar Cake","Juices","Muffins","Plain Cakes","Plum Cake","Slice Cake","Spreads","Tea Cakes","Wheat Cakes"
]

export const GalleryImage = [
    {
        "id": 1,
        "name": "Celebration Cakes",
        "Category": "Celebration Cakes",
        "imgSrc": "images/home/celebrationcakes.jpg",
        "description": "Celebrate in style with our wholesome wheat cakes."
    },
    {
        "id": 2,
        "name": "Wheat / Millet Brownies",
        "Category": "milletbrownies",
        "imgSrc": "images/home/milletbrownies.png",
        "description": "Crafted with the finest ingredients and natural sweetness."
    },
    {
        "id": 3,
        "name": "Wheat Tea Cakes",
        "Category": "teacakes",
        "imgSrc": "images/home/teacakes.png",
        "description": "Savor the delightful and healthy flavors."
    },
    {
        "id": 4,
        "name": "Wheat Cup Cakes",
        "Category": "cupcakes",
        "imgSrc": "images/home/cupcake.jpg",
        "description": "Cup Cakes bursting with natural flavor and wholesome ingredients."
    },
    {
        "id": 5,
        "name": "Healthy Spreads",
        "Category": "spreads",
        "imgSrc": "images/home/spreads.jpg",
        "description": "Elevate your snacks with our healthy spreads."
    },
    {
        "id": 6,
        "name": "Wheat Slice Cake",
        "Category": "slicecake",
        "imgSrc": "images/home/slicecake.png",
        "description": "A slice of celebration with wholesome ingredients."
    },
    {
        "id": 7,
        "name": "Wheat Plain Cake",
        "Category": "plaincake",
        "imgSrc": "images/home/plaincake.png",
        "description": "Enjoy the timeless taste of health with our naturally sweet plain cakes."
    },
    {
        "id": 8,
        "name": "Garlic Bun Cake",
        "Category": "Bun Cake",
        "imgSrc": "images/home/garlic_cake.jpeg",
        "description": "A Garlic Bun Cake, crafted for your health and happiness."
    },
    {
        "id": 9,
        "name": "Wheat Cookies",
        "Category": "cookies",
        "imgSrc": "images/home/cookies.png",
        "description": "Enjoy the perfect balance of natural taste and health."
    },
    {
        "id": 10,
        "name": "Pizza",
        "Category": "pizza",
        "imgSrc": "images/home/pizza.jpeg",
        "description": "Experience a slice of happiness with our light and flavorful pizza."
    },
    {
        "id": 11,
        "name": "100% Whole Wheat Bread",
        "Category": "breads",
        "imgSrc": "images/home/breads.png",
        "description": "Enjoy the goodness of 100% whole Wheat in every slice."
    }
]